import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Licówki porcelanowe'}>
      <Helmet title={"Licówki porcelanowe - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
